// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-2686840c] {\n  font-size: 24px;\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n}\n.subtitle[data-v-2686840c] {\n  font-size: 20px;\n  font-weight: 400;\n  margin: 0;\n  padding: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
